var JobMatchQueryFilter = /** @class */ (function () {
    function JobMatchQueryFilter() {
        this.candidateId = "";
        this.userId = "";
        this.companyId = "";
        this.top5Flag = true;
        this.candidateType = "";
        this.searchText = "";
        this.vendorIds = [];
    }
    return JobMatchQueryFilter;
}());
export { JobMatchQueryFilter };
//# sourceMappingURL=jobMatchQueryFilter.js.map